<script lang="ts">
	import '../app.css';
	import { page } from '$app/state';

	let { children } = $props();
</script>

<svelte:head>
	{#key page.url}
		<title>snuffyDev | {page.data.seoMetadata?.title || 'Personal Site'}</title>
		<meta
			name="description"
			content={page.data.seoMetadata?.description ||
				'My little corner of the internet where I share my thoughts and projects'}
		/>
		<meta name="og:title" content={page.data.seoMetadata?.title || 'snuffyDev'} />
		<meta
			name="og:description"
			content={page.data.seoMetadata?.description ||
				'My little corner of the internet where I share my thoughts and projects'}
		/>
		<meta
			name="og:image"
			content={page.data.seoMetadata?.image || 'https://snuffy.dev/favicon.png'}
		/>
		<meta name="og:url" content={page.url.toString()} />
		<meta name="twitter:card" content="summary_large_image" />
		<meta name="twitter:title" content={page.data.seoMetadata?.title || 'snuffyDev'} />
		<meta
			name="twitter:description"
			content={page.data.seoMetadata?.description ||
				'My little corner of the internet where I share my thoughts and projects'}
		/>
		<meta
			name="twitter:image"
			content={page.data.seoMetadata?.image || 'https://snuffy.dev/favicon.png'}
		/>
		<meta name="twitter:url" content={page.url.toString()} />
	{/key}
</svelte:head>
{@render children()}
